import { render, staticRenderFns } from "./JeecgOrderCustomerModal.vue?vue&type=template&id=608d7620&scoped=true&"
import script from "./JeecgOrderCustomerModal.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderCustomerModal.vue?vue&type=style&index=0&id=608d7620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608d7620",
  null
  
)

export default component.exports